<script>
  import {
    Lightbox,
    LightboxGallery,
    GalleryThumbnail,
    GalleryImage
  } from "svelte-lightbox"

  export let gallery

  let lightboxProgrammaticController

  const arrowsConfig = {
    galleryArrowsCharacter: "hide",
    enableKeyboardControl: true
  }

  function removeImage(el) {
    el.preventDefault()

    fetch(el.currentTarget.href, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      }
    }).then(() => window.location.reload())
  }
</script>

<LightboxGallery {arrowsConfig}>
  <!-- Layout-->
  <svelte:fragment slot="thumbnail">
    {#each gallery as { removeUrl, thumbnail }, id}
      <div class="group py-2 relative">
        <a
          class="hidden group-hover:flex items-center justify-center absolute top-4 right-4 w-6 h-6
          bg-bg/90 rounded-md text-danger hover:text-danger-hover transition-colors shadow-sm"
          href={removeUrl}
          title="Delete image"
          on:click={removeImage}><i class="fa-regular fa-trash-can text-xs"></i></a
        >
        <GalleryThumbnail {id}>
          <div class="aspect-square w-full bg-gray-100 rounded-lg overflow-hidden">
            <img
              class="block object-cover object-center w-full h-full hover:cursor-pointer"
              src={thumbnail}
              alt="Gallery thumbnail"
              loading="lazy"
            />
          </div>
        </GalleryThumbnail>
      </div>
    {/each}
  </svelte:fragment>

  {#each gallery as { type, src }}
    <GalleryImage>
      {#if type == "image"}
        <img {src} alt="Recipe" />
      {:else if type == "video"}
        <video {src} controls autoplay>
          <track kind="captions" />
        </video>
      {:else}
        <p>Unknown content type {type}</p>
      {/if}
    </GalleryImage>
  {/each}
</LightboxGallery>
